/**
 * Composant en-tête de l'interface d'administration
 * @module admin/components/AdminHeader
 */

import React from 'react';
import PropTypes from 'prop-types';

/**
 * Composant en-tête admin
 * @param {Object} props
 * @param {Object} props.user - Informations de l'utilisateur connecté
 * @param {function} props.onLogout - Fonction appelée lors de la déconnexion
 * @returns {JSX.Element}
 */
const AdminHeader = ({ user, onLogout }) => {
  return (
    <header className="admin-header">
      <h1>Administration</h1>
      <div className="admin-user-info">
        <span>
          Connecté : <strong>{user?.username}</strong>
        </span>
        <button
          type="button"
          className="admin-logout-button"
          onClick={onLogout}
          aria-label="Se déconnecter"
        >
          Déconnexion
        </button>
      </div>
    </header>
  );
};

AdminHeader.propTypes = {
  user: PropTypes.shape({
    username: PropTypes.string,
  }),
  onLogout: PropTypes.func.isRequired,
};

export default AdminHeader;
